import { Timestamp } from 'firebase/firestore';
import { format, parseISO, isValid } from 'date-fns';

const toDate = (date: any): Date | null => {
  if (!date) return null;
  if (date instanceof Timestamp) return date.toDate();
  if (date instanceof Date && isValid(date)) return date;
  if (typeof date === 'string') {
    const parsed = parseISO(date);
    if (isValid(parsed)) return parsed;
  }
  return null;
};

export function formatDate(date: any): string {
  const d = toDate(date);
  if (!d) return 'Invalid Date';
  return format(d, 'PP'); // e.g., Jul 2, 2025
}

export function formatTime(date: any): string {
  const d = toDate(date);
  if (!d) return 'Invalid Time';
  return format(d, 'p'); // e.g., 12:00 PM
}

export function getDaysBetween(startDate: any, endDate: any): number {
  const start = toDate(startDate);
  const end = toDate(endDate);
  if (!start || !end) return 0;
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.round(Math.abs((end.getTime() - start.getTime()) / oneDay));
}

export function addDays(date: any, days: number): Date {
  const d = toDate(date);
  if (!d) return new Date();
  const result = new Date(d);
  result.setDate(result.getDate() + days);
  return result;
}

export function isSameDay(date1: any, date2: any): boolean {
  const d1 = toDate(date1);
  const d2 = toDate(date2);
  if (!d1 || !d2) return false;
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}